class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.currentPageType = null;
    this.currentIdentifier = null;
  }

  connectedCallback() {
    this.grid = this.querySelector('[data-items-grid]');
    this.button = this.querySelector('[data-button]');
    this.countEl = document.querySelector('[data-items-current-count]');

    this.currentPageType = this.getCurrentPageType();
    this.currentIdentifier = this.getCurrentIdentifier();

    if (!this.currentIdentifier || !this.grid || !this.button) return;

    this.button.addEventListener('click', this.handleLoadMoreClick.bind(this));
  }

  /* ----------------------------
   * Page / Identifier detection
   * ---------------------------- */

  getCurrentPageType() {
    if (this.grid?.dataset?.pageType) return this.grid.dataset.pageType;

    const path = window.location.pathname;
    if (path.includes('/search')) return 'search';
    if (path.includes('/collections/')) return 'collection';
    if (path.includes('/blogs/')) return 'blog';

    return null;
  }

  getCurrentIdentifier() {
    switch (this.currentPageType) {
      case 'search':
        return new URLSearchParams(location.search).get('q');
      case 'collection':
        return this.getCollectionHandle();
      case 'blog':
        return this.getBlogHandle();
      default:
        return null;
    }
  }

  getBlogHandle() {
    return location.pathname.match(/\/blogs\/([^\/]+)/)?.[1] || null;
  }

  getCollectionHandle() {
    return (
      new URLSearchParams(location.search).get('collection') ||
      document.querySelector('[data-collection-handle]')?.dataset?.collectionHandle ||
      location.pathname.match(/\/collections\/([^\/]+)/)?.[1] ||
      null
    );
  }

  /* ----------------------------
   * Load-more handling
   * ---------------------------- */

  handleLoadMoreClick() {
    const {
      perPage = 0,
      totalItems,
      totalProducts
    } = this.grid.dataset;

    const total =
      this.currentPageType === 'blog'
        ? parseInt(totalItems || Infinity)
        : parseInt(totalProducts || Infinity);

    this.loadNextPage({
      grid: this.grid,
      loadMoreBtn: this.button,
      updateCount: (page) => {
        if (!this.countEl || !perPage) return;

        let count = page * parseInt(perPage);
        if (count > total) count = total;

        this.countEl.textContent = count;
      }
    });
  }

  async loadNextPage({ grid, loadMoreBtn, updateCount }) {
    const nextUrl = grid.dataset.nextUrl;
    const currentPage = parseInt(grid.dataset.currentPage);
    const totalPages = parseInt(grid.dataset.totalPages);

    if (!nextUrl) return;

    loadMoreBtn.classList.add('loading');

    try {
      const html = await fetch(nextUrl).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('[data-items-grid]');
      const allItems = this.querySelectorAll('[data-sort-item]');
      if (!newGrid) return;

      // reset order
      if (allItems?.length) {
        allItems.forEach(item => {
          item.style.order = 0;
        });
      }

      grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);

      const newPage = currentPage + 1;
      grid.dataset.currentPage = newPage;
      grid.dataset.nextUrl = newGrid.dataset.nextUrl || '';

      updateCount?.(newPage);

      // Re-initialize wishlist icons for newly loaded items
      if (typeof updateWishlistIcons === 'function' && typeof maWishlist !== 'undefined' && typeof maWishlisttemplate !== 'undefined') {
        updateWishlistIcons(maWishlisttemplate, maWishlist);
      }

      if (newPage >= totalPages) {
        loadMoreBtn.style.display = 'none';
      }
    } catch (err) {
      console.error('Load more failed:', err);
    } finally {
      loadMoreBtn.classList.remove('loading');
    }
  }
}

customElements.define('load-more', LoadMore);
